namespace TabAurous {
    export interface CommonTrans {
        TransId?: number;
        RefTransId?: number;
        RefVoucherId?: number;
        PartyId?: number;
        POSCustomerId?: number;
        TransItemId?: number;
        VoucherNo?: string;
        TransDate?: string;
        VoucherDate?: string;
        VoucherTypeId?: number;
        CompanyId?: number;
        FinancialYearId?: number;
        AutoPosting?: boolean;
        ItemDetails?: CommonStock[];
    }
}
